import { api } from '@api'
import { toaster } from '@/components/ui/toast'

export const whenDeleting = async (id: string) => {
	if (!id) return

	// Call your Supabase function or use Supabase client here
	// Example using Supabase client directly:
	const { error } = await api().from('message').delete().eq('id', id)

	if (error) {
		console.error('Failed to delete message:', error)
		throw error
	}
}
